<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/clueBusiness/findBusinessClueBusinessList.action"
                    ref="Table">
      <template slot="search">
        <el-row>
          <el-form :inline="true" >

            <el-form-item>
              <el-date-picker
                      @change="onDateTimeChange"
                      end-placeholder="领取结束日期"
                      range-separator="至"
                      start-placeholder="领取开始日期"
                      type="datetimerange"
                      v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-date-picker
                      @change="onMaintenanceDateTimeChange"
                      end-placeholder="维护结束日期"
                      range-separator="至"
                      start-placeholder="维护开始日期"
                      type="datetimerange"
                      v-model="queryParams.maintenanceStartEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-date-picker
                      @change="onRegisterDateTimeChange"
                      end-placeholder="注册结束日期"
                      range-separator="至"
                      start-placeholder="注册开始日期"
                      type="datetimerange"
                      v-model="queryParams.startEndRegisterTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-select v-model="queryParams.status" placeholder="状态"  @change="$refs.Table.search()"  :clearable="true" :filterable="true">
                <el-option :value="1" label="待维护"></el-option>
                <el-option :value="2" label="待添加"></el-option>
                <el-option :value="3" label="待拉群"></el-option>
                <el-option :value="4" label="已维护"></el-option>
                <el-option :value="5" label="无效"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-model="queryParams.registerStatus"  @change="$refs.Table.search()" placeholder="是否注册" :clearable="true" :filterable="true">
                <el-option :value="1" label="已注册"></el-option>
                <el-option :value="2" label="未注册"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-model="queryParams.subStatus"  @change="$refs.Table.search()" placeholder="是否关注" :clearable="true" :filterable="true">
                <el-option :value="1" label="已关注"></el-option>
                <el-option :value="2" label="未关注"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-model="queryParams.sortType"  @change="$refs.Table.search()" placeholder="排序" :clearable="true" :filterable="true">
                <el-option :value="1" label="领取时间"></el-option>
                <el-option :value="2" label="注册时间"></el-option>
                <el-option :value="3" label="维护时间"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item  >
              <el-input style="width: 320px" placeholder="搜索用户手机号|邀请人手机号|维护人|区域" v-model="queryParams.keyword"></el-input>
            </el-form-item>
            <el-form-item  >
              <el-input  placeholder="无效标签" v-model="queryParams.ignoreTag"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$refs.Table.search()" type="warning">搜索</el-button>
            </el-form-item>

            <el-form-item>
              <el-button @click="exportExcel()" type="warning" v-belong-to-admin>导出</el-button>
            </el-form-item>

          </el-form>
        </el-row>

      </template>
      <template slot="item">

        <el-table-column
            label="用户信息"
            width="200px"
        >
          <template slot-scope="scope">
            <p>{{scope.row.phone}} </p>
            <p>{{ scope.row.company }}</p>
          </template>
        </el-table-column>
        <el-table-column
            label="地区"
        >
          <template slot-scope="scope">
          <p>{{scope.row.city}} </p>
          </template>

        </el-table-column>
          <el-table-column
                  label="状态"
                  width="120px"
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click"  width="100px">
                <el-button class="el-dropdown-link" size="mini" type="primary">
                  {{ scope.row.status|statusFilter }}<i class="el-icon-caret-bottom el-icon--right" style="color:#FFF"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native.prevent="changeClueBusinessStatus(scope.row.id,1)" >待维护</el-dropdown-item>
                  <el-dropdown-item @click.native.prevent="changeClueBusinessStatus(scope.row.id,2)" >待添加</el-dropdown-item>
                  <el-dropdown-item @click.native.prevent="changeClueBusinessStatus(scope.row.id,3)" >待拉群</el-dropdown-item>
                  <el-dropdown-item @click.native.prevent="changeClueBusinessStatus(scope.row.id,4)" >已维护</el-dropdown-item>
                  <el-dropdown-item @click.native.prevent="changeClueBusinessStatus(scope.row.id,5)" >无效</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <p v-if="scope.row.status==5&&scope.row.ignoreTag">无效标签：{{scope.row.ignoreTag}}</p>

            </template>
          </el-table-column>
        <el-table-column
                label="维护时间"
        >
          <template scope="scope">
            <p>{{scope.row.maintenanceLastTime | dateTimeFormat}}</p>
            <p v-if="scope.row.maintenanceName" style="color: red" >维护人：{{scope.row.maintenanceName}}</p>
          </template>
        </el-table-column>
        <el-table-column
            label="是否注册"
        >
          <template scope="scope">

          <p v-if="scope.row.registerStatus == 1">已注册({{scope.row.registercreateTime | dateTimeFormat}})
          </p>

            <p v-if="scope.row.registerStatus == 2">
               未注册
            </p>

          </template>
        </el-table-column>

        <el-table-column
                label="是否关注"
        >
          <template scope="scope">

            <p v-if="scope.row.subStatus == 1">已关注
            </p>

            <p v-if="scope.row.subStatus == 2">
              未关注
            </p>

          </template>
        </el-table-column>

        <el-table-column
                label="邀请人信息"
        >
          <template scope="scope">

            <p v-if="scope.row.inviterEmployeePhone">
              {{scope.row.inviterEmployeePhone}}-{{scope.row.inviterEmployeeName}}
            </p>

          </template>
        </el-table-column>

        <el-table-column
                label="领取时间"
        >
          <template scope="scope">

            {{scope.row.receiveTime | dateTimeFormat}}
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
import Config from '@/framework/configs/Config'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'clueBusinessIntranetManagement',
  data: function () {
    return {
      urlDialogVisible: false,
      urlVal: '暂无',
      queryParams: {
        status: null,
        startTime: null,
        endTime: null,
        startEndTime: null,
        maintenanceStartTime: null,
        maintenanceEndTime: null,
        keyword: null,
        registerStatus: null,
        subStatus: null,
        endRegisterTime: null,
        startRegisterTime: null,
        ignoreTag: null,
        sortType: null

      }
    }
  },
  watch: {
    'queryParams.ignoreTag': function (val) {
      if (val === '') {
        this.queryParams.ignoreTag = null
      }
    }
  },
  methods: {
    openUrl: function (shareUrl) {
      this.urlDialogVisible = true
      this.urlVal = shareUrl
    },
    exportExcel: function () {
      let _this = this

      let dataStr = ''

      if (this.queryParams.status) {
        dataStr += '&status=' + this.queryParams.status
      }
      if (this.queryParams.registerStatus) {
        dataStr += '&registerStatus=' + this.queryParams.registerStatus
      }

      if (this.queryParams.subStatus) {
        dataStr += '&subStatus=' + this.queryParams.subStatus
      }

      if (this.queryParams.startTime) {
        dataStr += '&startTime=' + this.queryParams.startTime
      }
      if (this.queryParams.endTime) {
        dataStr += '&endTime=' + this.queryParams.endTime
      }

      if (this.queryParams.keyword) {
        dataStr += '&keyword=' + this.queryParams.keyword
      }

      if (this.queryParams.maintenanceStartTime) {
        dataStr += '&maintenanceStartTime=' + this.queryParams.maintenanceStartTime
      }

      if (this.queryParams.endRegisterTime) {
        dataStr += '&endRegisterTime=' + this.queryParams.endRegisterTime
      }

      if (this.queryParams.sortType) {
        dataStr += '&sortType=' + this.queryParams.sortType
      }

      if (this.queryParams.startRegisterTime) {
        dataStr += '&startRegisterTime=' + this.queryParams.startRegisterTime
      }

      if (this.queryParams.maintenanceEndTime) {
        dataStr += '&maintenanceEndTime=' + this.queryParams.maintenanceEndTime
      }
      if (this.queryParams.ignoreTag) {
        dataStr += '&ignoreTag=' + this.queryParams.ignoreTag
      }

      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      window.location.href = Config.baseUrl + 'clueBusiness/findBusinessClueBusinessListExcel.action?' + 'token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    },
    changeClueBusinessStatus (id, status) {
      let _this = this
      let params = { id: id, status: status }
      let listener = {
        success: function (dataInfo) {
          _this.$message({
            type: dataInfo.success ? 'success' : 'error',
            message: dataInfo.errMsg
          })
          _this.$refs.Table.search()
        }

      }

      BasicModel.post(_this, '/clueBusiness/changeClueBusinessStatus.action', params, listener)
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.Table.search()
    },
    onMaintenanceDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.maintenanceStartTime = dates[0].getTime()
        this.queryParams.maintenanceEndTime = dates[1].getTime()
      } else {
        this.queryParams.maintenanceStartTime = null
        this.queryParams.maintenanceEndTime = null
      }
      this.$refs.Table.search()
    },
    onRegisterDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startRegisterTime = dates[0].getTime()
        this.queryParams.endRegisterTime = dates[1].getTime()
      } else {
        this.queryParams.startRegisterTime = null
        this.queryParams.endRegisterTime = null
      }
      this.$refs.Table.search()
    }
  },
  filters: {
    statusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '待维护'
          break
        case 2:
          str = '待添加'
          break
        case 3:
          str = '待拉群'
          break
        case 4:
          str = '已维护'
          break
        case 5:
          str = '无效'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
